const Areas = [
	{
		"url": "article",
		"name": "Article",
		"plural": "Articles",
		"roles": ["article.contributor", "article.approver"],
		"features": ["hiddenDescription", "content", "redirect", "tags", "private", "breadcrumbs", "print", "publicList", "socialButtons"]
	},
	{
		"url": "showcase",
		"name": "Showcase page",
		"plural": "Showcase pages",
		"roles": ["showcase.contributor", "showcase.approver"],
		"features": ["hiddenDescription", "content", "video", "image", "tags", "redirect", "private", "breadcrumbs", "print", "publicList", /*"noChipsInSearchPreview",*/ "socialButtons"]
	},
	{
		"url": "collection",
		"name": "Collection",
		"plural": "Collections",
		"roles": ["collection.contributor", "collection.approver"],
		"features": ["hiddenDescription", "content", "tags", "items", "redirect", "private", "breadcrumbs", "print", "socialButtons"]
	},
	{
		"url": "page",
		"name": "Page",
		"plural": "Pages",
		"roles": ["page.contributor", "page.approver"],
		"features": ["hiddenDescription", "content", "tags", "redirect", "private", "breadcrumbs", "simplebreadcrumbs", "socialButtons"]
	},
	{
		"url": "unlisted",
		"name": "Unlisted page",
		"plural": "Unlisted pages",
		"roles": ["unlisted.contributor", "unlisted.approver"],
		"features": ["content", "redirect", "private"]
	},
	{
		"url": "renaissance_showcase",
		"name": "renAIssance Showcase page",
		"plural": "renAIssance Showcase",
		"roles": ["renaissance_showcase.contributor", "renaissance_showcase.approver"],
		"features": ["video", "image", "tags", "publicList", "socialButtons"]
	},
	{
		"url": "renaissance_events",
		"name": "renAIssance Events page",
		"plural": "renAIssance Events",
		"roles": ["renaissance_events.contributor", "renaissance_events.approver"],
		"features": ["content", "tags", "publicList", "private", "events", "homepage_private"]
	},
	{
		"url": "template",
		"name": "Template",
		"plural": "Templates",
		"roles": ["admin"],
		"features": ["hiddenDescription", "content", "video", "tags", "events", "private"]
	},
	{
		"url": "search",
		"name": "Search Result",
		"plural": "Search results",
		"meta": true,
		"roles": [],
		"features": ["publicList"]
	}
];

export default Areas;